// Navigation context is never authentication; the API must verify the owner.
export const checkoutContextFromSearch = (search = '') => {
  const query = new URLSearchParams(search);
  return Object.fromEntries([
    ['continuation', query.get('continuation')],
    ['sessionId', query.get('session_id')],
    ['checkoutContext', query.get('checkout_context')],
    ['intakeId', query.get('intakeId')],
  ].filter(([, value]) => value !== null));
};

export const withCheckoutContext = (path, context = {}) => {
  const query = new URLSearchParams();
  if (context.continuation !== undefined) query.set('continuation', context.continuation);
  if (context.sessionId !== undefined) query.set('session_id', context.sessionId);
  if (context.checkoutContext !== undefined) query.set('checkout_context', context.checkoutContext);
  if (context.intakeId !== undefined) query.set('intakeId', context.intakeId);
  return query.toString() ? `${path}${path.includes('?') ? '&' : '?'}${query}` : path;
};

export const checkoutContextBody = (context) =>
  Object.keys(context || {}).length ? { context } : {};

export const checkoutContextForIntake = (context, intake) =>
  Object.keys(context || {}).length ? context :
    (intake?.id || intake?._id) ? { intakeId: String(intake.id || intake._id) } : {};

export const checkoutRetryBody = (retry, intake) =>
  retry?.allowed === true && retry.intakeId === String(intake?.id || intake?._id || '') && retry.attemptId
    ? { context: { intakeId: retry.intakeId }, retryAttemptId: retry.attemptId }
    : null;
